<div class="logo">
  <a (click)="getRoute()"><img class="new_logo_blue" src="assets/images/logo.webp" /></a>
</div>